import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { trackSignUpClick } from "@faire/retailer-visitor-shared/lib/popSignUpUtils";
import qs from "query-string";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
export var SignUpSource;
(function(SignUpSource) {
    SignUpSource["CATNAV_SIGNUP_CTA"] = "catnav_signup_cta";
    SignUpSource["AUTO_SEM_BOTTOM_BANNER"] = "auto-sem-bottom-banner";
    SignUpSource["FAIRE_MARKET_SIGNUP_CTA"] = "faire_market_signup_cta";
})(SignUpSource || (SignUpSource = {}));
export var SignUpType;
(function(SignUpType) {
    SignUpType["GENERIC"] = "1";
    SignUpType["AUTO"] = "auto";
    SignUpType["FACEBOOK"] = "facebook";
    SignUpType["PRODUCT"] = "product";
    SignUpType["BRAND"] = "brand";
    SignUpType["FAIRE_DIRECT"] = "direct";
    SignUpType["WIDGET"] = "widget";
    SignUpType["WIDGET_V2"] = "widgetv2";
    SignUpType["FAIRE_DIRECT_REQUIRE_EMAIL"] = "directrequireemail";
    SignUpType["TRADESHOW"] = "tradeshow";
    SignUpType["RETAILER_SUBUSER"] = "retailersubuser";
    SignUpType["RETAILER_LEAD_ADS"] = "retailerleadads";
    SignUpType["FOI_BANNER"] = "foibanner";
    SignUpType["PAID_ADS"] = "paidads";
    SignUpType["SEM"] = "sem";
})(SignUpType || (SignUpType = {}));
/**
 * This should be an exhaustive list of Faire Direct `signUp`
 * types. No other type should receive the Faire Direct credit.
 */ export var FaireDirectSignUpTypes = [
    SignUpType.FAIRE_DIRECT,
    SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL,
    SignUpType.WIDGET,
    SignUpType.WIDGET_V2,
    SignUpType.TRADESHOW
];
/**
 * Element list to identify which general part of a page
 * was interacted with to show signup modal
 */ export var SignUpElement;
(function(SignUpElement) {
    SignUpElement["HEADER"] = "HEADER";
    SignUpElement["FOOTER"] = "FOOTER";
    SignUpElement["HERO"] = "HERO";
    SignUpElement["CATNAV"] = "CATNAV";
    SignUpElement["NUDGE"] = "NUDGE";
    SignUpElement["PRODUCT_GRID"] = "PRODUCT_GRID";
    SignUpElement["CAROUSEL"] = "CAROUSEL";
    SignUpElement["BELOW_FOLD"] = "BELOW_FOLD";
    SignUpElement["TOP_BANNER"] = "TOP_BANNER";
    SignUpElement["AUTO_POPUP"] = "AUTO_POPUP";
    SignUpElement["LIST"] = "LIST";
    SignUpElement["MODAL"] = "MODAL";
    SignUpElement["SNACKBAR"] = "SNACKBAR";
})(SignUpElement || (SignUpElement = {}));
export var popSignUp = function(history, type, trackingFunction, trackingParams) {
    var extraParams = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    trackingFunction();
    trackSignUpClick(type, trackingParams.element, trackingParams.sourceId);
    history.replace(_object_spread_props(_object_spread({}, history.location), {
        search: qs.stringify(_object_spread(_object_spread_props(_object_spread({}, qs.parse(history.location.search)), {
            signUp: type
        }), extraParams))
    }));
};
export var usePopSignUp = function() {
    var history = useHistory();
    return {
        popSignUp: function(type, trackingFunction, trackingParams) {
            var extraParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            trackingFunction();
            trackSignUpClick(type, trackingParams.element, trackingParams.sourceId);
            history.replace(_object_spread_props(_object_spread({}, history.location), {
                search: qs.stringify(_object_spread(_object_spread_props(_object_spread({}, qs.parse(history.location.search)), {
                    signUp: type
                }), extraParams))
            }));
        }
    };
};
export var useTrackSignupModalOpenClick = function() {
    return useCallback(function(type, element, sourceId) {
        trackSignUpClick(type, element, sourceId);
    }, []);
};
